/* eslint-disable no-unused-vars */
/* eslint-disable consistent-return */
/* eslint-disable max-len */
/* eslint-disable no-shadow */
/* eslint-disable camelcase */
import {
  Box,
  Button,
  CircularProgress,
  OutlinedInput,
  Paper,
  Typography,
} from '@material-ui/core'
// import icons from '@assets/icons'
import React, { Fragment, useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { Link, useHistory } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import { useSnackbar } from 'notistack'
import { resellerApi, resellerApiWithToken } from '@api/baseApi'
import FieldPackageChooser from '@components/CustomFields/FieldPackageChooser'
import application from '@config/application'
import RadioPaymentChannels from '@components/CustomFields/RadioPaymentChannels'
import useAxios from '@hooks/useAxios'
import getDomain from '@config/domain'
import Cookies from 'js-cookie'
import { rules, schema } from '@config/yup.schema'
import { yupResolver } from '@hookform/resolvers/yup'
import { matchDomain } from '@config/helpers'
import useStyles from './styles-jss/register-jss'
import FormRegister from './FormRegister'
import LoginDialog from './LoginDialog'
import AffiliateForm from './AffiliateForm'
import AffiliateForm2 from './AffiliateForm2'

const hookFormConfig = {
  defaultValues: {
    name: '',
    email: '',
    phone: '',
    password: '',
    password_confirmation: '',
    address: '',
    district: null,
  },
  resolver: yupResolver(
    schema({
      name: rules.stringRequired,
      email: rules.email,
      phone: rules.phoneNumber,
      password: rules.passwordOptional,
      password_confirmation: rules.passwordOptional,
      address: rules.stringRequired,
      district: rules.mixed,
    }),
  ),
}

const AffiliateRegister = () => {
  const classes = useStyles()

  const {
    errors,
    control,
    handleSubmit,
    getValues,
    setValue,
    register,
    reset,
    watch,
  } = useForm(hookFormConfig)

  const hookForm = {
    errors,
    control,
    getValues,
    setValue,
    register,
    reset,
    watch,
  }

  const [isSubmitting, setSubmitting] = useState(false)
  const { enqueueSnackbar } = useSnackbar()
  const history = useHistory()

  const onSubmit = async (data) => {
    // const { payment_method } = data

    const newParams = {
      name: data.name,
      email: data.email,
      phone: data.phone,
      password: data.password,
      password_confirmation: data.password_confirmation,
      address: data.address,
      customer_type_id: data.customer_type_id,
      district_id: data.district.id,
      domain: getDomain(),
      referral_code: data.referral_code,
      payment_method: data.payment_method,
      number: data.affiliate_code,
    }

    try {
      setSubmitting(true)
      const res = await resellerApi.post('api/v1/affiliates', newParams)
      const {
        status,
        data: { data },
      } = res
      if (status === 200) {
        setSubmitting(false)
        enqueueSnackbar('Pendaftarn Berhasil', {
          variant: 'success',
        })
        history.push(`${application.prefix}/affiliate`)
      } else {
        setSubmitting(false)
        // eslint-disable-next-line no-shadow
        const {
          data: { data },
        } = res
        if (Array.isArray(data)) {
          data.map((value) => enqueueSnackbar(value, {
            variant: 'error',
          }))
        } else {
          enqueueSnackbar('Maaf, Terjadi kesalahan pada sistem', {
            variant: 'error',
          })
        }
      }
    } catch (error) {
      setSubmitting(false)
      if (Array.isArray(error?.response?.data?.data)) {
        if (error?.response?.data?.data?.length > 0) {
          error?.response?.data?.data?.map((value) => enqueueSnackbar(value, {
            variant: 'error',
          }))
        } else {
          enqueueSnackbar(
            'Kode Affiliate sudah digunakan, silahkan coba kode lain',
            {
              variant: 'error',
            },
          )
        }
      } else {
        enqueueSnackbar('Maaf, Terjadi kesalahan pada sistem', {
          variant: 'error',
        })
      }
    }
  }

  return (
    <Fragment>
      <Helmet>
        <title>{application.name} | Register</title>
      </Helmet>
      <form
        onSubmit={handleSubmit(onSubmit)}
        autoComplete="off"
        className={classes.root}
      >
        <Box className={classes.background}>
          {/* {
          matchDomain(window.location.hostname)
          && (
          <img
            src={icons.AppLogoWhite}
            height={138}
            width={110}
            alt="logo"
            className={classes.logo}
          />
          )
        } */}
          <div style={{ width: 110, height: 138 }} />
        </Box>
        <Box className={classes.content}>
          <Box className={classes.column}>
            <AffiliateForm {...hookForm} />
          </Box>
          <Box className={classes.column}>
            <AffiliateForm2 {...hookForm} />
          </Box>
          <Paper className={classes.footer}>
            <div className={classes.loginLink}>
              <Typography
                variant="subtitle2"
                className={classes.loginLinkLabel}
              >
                Punya akun?
              </Typography>
              <Button
                color="primary"
                component={Link}
                to={`${application.prefix}/affiliate`}
              >
                Masuk
              </Button>
            </div>

            <Button
              type="submit"
              className={classes.btnSubmit}
              color="primary"
              variant="contained"
            >
              {isSubmitting ? (
                <CircularProgress color="secondary" size={24} />
              ) : (
                'Daftar Sekarang'
              )}
            </Button>
          </Paper>
        </Box>
      </form>
    </Fragment>
  )
}

export default AffiliateRegister
